import React, { useEffect } from 'react';
import Footer from './Components/Footer';
import Header from './Components/Header';
import MainHeader from './Components/MainHeader';
import SEOHelmet from './Components/SEOHelmet';

const PrivacyPolicy = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const sectionStyle = { marginBottom: '30px' };
    const headingStyle = { color: '#a04ff4', fontSize: '1.4rem', fontWeight: '600', marginBottom: '15px' };
    const textStyle = { fontSize: '1.05rem', lineHeight: '1.8', color: '#c4c8cc' };
    const listStyle = { ...textStyle, paddingLeft: '20px', marginBottom: '15px' };

    return (
        <div style={{ backgroundColor: '#0c001f', minHeight: '100vh', width: '100%', color: '#e0e0e0', fontFamily: "'Space Grotesk', sans-serif" }}>
            <Header />
            <MainHeader />
            <SEOHelmet
                title="Privacy Policy"
                description="Learn how Octalbees protects your privacy. We collect only essential data to deliver services and never sell or share your information with third parties."
                path="/privacy-policy"
            />
            
            <div className="container" style={{ paddingTop: '40px', paddingBottom: '80px' }}>
                <div className="row justify-content-center">
                    <div className="col-lg-10">
                        <div className="p-md-5">
                            <div className="mb-5">
                                <h1 className="fw-bold text-center" style={{ color: '#fff', fontSize: '2.5rem' }}>Privacy Policy</h1>
                            </div>

                            <div style={sectionStyle}>
                                <p style={{ color: '#a5b0bb', fontSize: '0.95rem', fontStyle: 'italic', marginBottom: '20px' }}>
                                    Last Updated: 29 August 2026
                                </p>
                                <p style={textStyle}>
                                    Octalbees ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or engage with our services.
                                </p>
                            </div>

                            <div style={sectionStyle}>
                                <h2 style={headingStyle}>1. Information We Collect</h2>
                                <p style={textStyle}>We collect information across our three main service areas (Client Services, Educational Courses, and Internships):</p>
                                <ul style={listStyle}>
                                    <li><strong>Personal Data:</strong> We may collect identifiable information such as your name, email address, phone number, and company/academic details when you fill out forms, request quotes, enroll in a course, or apply for an internship.</li>
                                    <li><strong>Academic & Performance Data:</strong> For students and interns, we may collect information regarding academic history, GitHub repositories, course progress, assignments, video testimonials, and overall performance evaluations.</li>
                                    <li><strong>Usage Data:</strong> We may automatically collect information about your IP address, browser type, operating system, and browsing behavior on our site to improve user experience.</li>
                                    <li><strong>Financial Data:</strong> For payment processing (client invoices or course fees), we use secure third-party payment gateways. We do not store your credit card details directly on our servers.</li>
                                </ul>
                            </div>

                            <div style={sectionStyle}>
                                <h2 style={headingStyle}>2. How We Use Your Information</h2>
                                <p style={textStyle}>We use the collected information for the following purposes:</p>
                                <ul style={listStyle}>
                                    <li>To deliver and manage our digital services, educational cohorts, and internship programs.</li>
                                    <li>To process transactions, manage course enrollments, and send related billing information.</li>
                                    <li>To evaluate internship performance, grade course projects, and issue completion certificates.</li>
                                    <li>To respond to customer service requests and provide technical/academic support.</li>
                                    <li>To send periodic emails regarding your project, cohort updates, or promotional offers (which you can opt out of at any time).</li>
                                </ul>
                            </div>

                            <div style={sectionStyle}>
                                <h2 style={headingStyle}>3. Data Sharing and Disclosure</h2>
                                <p style={textStyle}>
                                    We do not sell, trade, or rent your personal identification information to third parties. We may share generic aggregated demographic or performance information not linked to any personal identification information with our hiring partners (in the case of students/interns). We may share data with trusted third-party service providers (such as hosting partners and payment processors) who assist us in operating our business, provided those parties agree to keep this information confidential. We may also release information when required by law.
                                </p>
                            </div>

                            <div style={sectionStyle}>
                                <h2 style={headingStyle}>4. Cookies and Tracking Technologies</h2>
                                <p style={textStyle}>
                                    Our website may use "cookies" and similar tracking technologies to enhance user experience. Cookies are small files stored on your device that help us analyze site traffic and improve functionality. You can choose to set your web browser to refuse cookies or to alert you when cookies are being sent. If you do so, some parts of the site may not function properly.
                                </p>
                            </div>

                            <div style={sectionStyle}>
                                <h2 style={headingStyle}>5. Data Security & Retention</h2>
                                <p style={textStyle}>
                                    We implement appropriate technical and organizational security measures designed to protect your personal information against accidental or unlawful destruction, loss, or unauthorized access. However, no method of transmission over the Internet is 100% secure. We retain personal information only for as long as necessary to fulfill the purposes outlined in this policy or as required by law.
                                </p>
                            </div>

                            <div style={sectionStyle}>
                                <h2 style={headingStyle}>6. Your Data Rights</h2>
                                <p style={textStyle}>
                                    Depending on your jurisdiction (e.g., under GDPR or CCPA), you may have the right to request access to, correction of, or complete deletion of your personal data. You may also have the right to restrict or object to certain processing of your data. To exercise these rights, please contact us.
                                </p>
                            </div>

                            <div style={sectionStyle}>
                                <h2 style={headingStyle}>7. Contact Us</h2>
                                <p style={textStyle}>
                                    If you have any questions about this Privacy Policy or how we handle your data, please contact us at <a href="mailto:info@octalbees.com" style={{ color: '#a04ff4', textDecoration: 'none', fontWeight: 'bold' }}>info@octalbees.com</a>.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default PrivacyPolicy;
